export default function LiveIndicator({ active }: { active: boolean }) {
  if (!active) return null;

  return (
    <div className="flex items-center gap-1">
      <div className="w-1.5 h-1.5 rounded-full bg-severity-crit animate-pulse-scan" />
      <span className="text-[9px] readout text-severity-crit font-bold">LIVE</span>
    </div>
  );
}
